import { z } from "zod";
import { AnchoringStatus, ResponseStatus } from "../enums";
const statusEnum = z.union([z.nativeEnum(ResponseStatus), z.nativeEnum(AnchoringStatus)]);
const transactionStatusReponseSchema = z
    .object({
    statusCode: z.number().nullable(),
    result: z.object({
        status: statusEnum,
        rejectReason: z.string().optional(),
    }),
})
    .transform(({ statusCode, result }) => ({
    statusCode,
    status: result.status,
    rejectReason: result.rejectReason,
}));
export function validateTransactionStatusReponse(input) {
    const result = transactionStatusReponseSchema.safeParse(input);
    if (!result.success) {
        throw new Error("Model does not match TransactionStatusReponse");
    }
    return result.data;
}
//# sourceMappingURL=transactionStatusReponse.js.map